import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import NavbarId from "./data/lang/id/navbar.json";
import NavbarEn from "./data/lang/en/navbar.json";

import HeroId from "./data/lang/id/home/hero.json";
import HeroEn from "./data/lang/en/home/hero.json";

import AboutId from "./data/lang/id/home/about.json";
import AboutEn from "./data/lang/en/home/about.json";

import PodiumHomeId from "./data/lang/id/home/podium-category.json";
import PodiumHomeEn from "./data/lang/en/home/podium-category.json";

import PrizeHomeId from "./data/lang/id/home/prize.json";
import PrizeHomeEn from "./data/lang/en/home/prize.json";

import RulesRegulationId from "./data/lang/id/race-information/rules-regulation.json";
import RulesRegulationEn from "./data/lang/en/race-information/rules-regulation.json";

import AboutKidsDashId from "./data/lang/id/kids-dash/about.json";
import AboutKidsDashEn from "./data/lang/en/kids-dash/about.json";

import RulesRegulationKidsDashId from "./data/lang/id/kids-dash/rules-regulation-kids-dash.json";
import RulesRegulationKidsDashEn from "./data/lang/en/kids-dash/rules-regulation-kids-dash.json";

import faqId from "./data/lang/id/race-information/faq.json";
import faqEn from "./data/lang/en/race-information/faq.json";

import PrizeId from "./data/lang/id/race-information/prize.json";
import PrizeEn from "./data/lang/en/race-information/prize.json";

import ContactId from "./data/lang/id/contact-us.json";
import ContactEn from "./data/lang/en/contact-us.json";

import RaceDayId from "./data/lang/id/race-information/raceday.json";
import RaceDayEn from "./data/lang/en/race-information/raceday.json";

import RegistrationId from "./data/lang/id/registration.json";
import RegistrationEn from "./data/lang/en/registration.json";

const resources = {
    en: {
        translation: {
            navbar: NavbarEn,
            hero: HeroEn,
            footer: {
                page: "Pages",
                social: "Social Media",
            },
            home: {
                about: AboutEn,
                podium: PodiumHomeEn,
                prize: PrizeHomeEn,
                login: "Register Now",
                profile: "Profile",
                logout: "Logout",
            },
            login: {
                title: "Sign",
                subTitle: "In",
                email: "Email",
                emailPlaceholder: "Enter your email",
                password: "Password",
                passwordPlaceholder: "Enter your password",
                login: "Login",
                ctaRegisterNow: "Register Now",
                successMessage: "Login successful",
                failedMessage: "Login failed",
                genericErrorMessage: "An error occurred, please try again",
                unverifiedModal: {
                    title: "Account Not Verified",
                    description: "Your account has not been verified. Please check your email for verification instructions.",
                    close: "Close",
                    resendVerification: "Resend Verification",
                },
            },
            profile: {
                title: "Profile",
                actions: {
                    registerEvent: "Register Event",
                    eventHistory: "Event History",
                },
                sections: {
                    personalInfo: "Personal Information"
                },
                fields: {
                    uusrName: "Name",
                    uusrEmail: "Email",
                    uusrPhoneNumber: "Phone Number",
                    uusrGender: "Gender",
                    uusrBloodType: "Blood Type",
                    uusrNationality: "Nationality",
                    uusrIdentityType: "Identity Type",
                    uusrIdentityNumber: "Identity Number",
                    uusrDateOfBirth: "Date of Birth",
                    uusrOccupation: "Occupation",
                    uusrCommunity: "Community",
                },
                gender: {
                    1: "Male",
                    2: "Female",
                },
                identityType: {
                    1: "ID CARD",
                    2: "PASSPORT",
                },
            },
            gallery: {
                title: "Gallery",
            },
            raceinfo: {
                rrTitle:
                    "All participants are required to read and understand the rules and regulations below before registering for the Suroboyo 10K.",
                rr: RulesRegulationEn,
                rrHeader: "Rules &",
                rrHeaderSub: "Regulations",
                faqHeader: "Frequently Asked Question",
            },
            prize: PrizeEn,
            faq: faqEn,
            raceday: RaceDayEn,
            contact: ContactEn,
            registration: RegistrationEn,
            kidsDash: {
                about: AboutKidsDashEn,
                rrkdTitle:
                    "All participants are required to read and understand the rules and regulations below before registering for the Kids Dash Semarang 10K.",
                rrkd: RulesRegulationKidsDashEn,
            }
        },
    },
    id: {
        translation: {
            navbar: NavbarId,
            hero: HeroId,
            footer: {
                page: "Halaman",
                social: "Media Sosial",
            },
            login: {
                title: "Masuk",
                subTitle: "",
                email: "Email",
                emailPlaceholder: "Masukkan email Anda",
                password: "Kata Sandi",
                passwordPlaceholder: "Masukkan kata sandi Anda",
                login: "Masuk",
                ctaRegisterNow: "Daftar Sekarang",
                successMessage: "Login berhasil",
                failedMessage: "Login gagal",
                genericErrorMessage: "Terjadi kesalahan, silakan coba lagi",
                unverifiedModal: {
                    title: "Akun Tidak Terverifikasi",
                    description: "Akun Anda belum diverifikasi. Silakan periksa email Anda untuk instruksi verifikasi.",
                    close: "Tutup",
                    resendVerification: "Kirim Ulang Verifikasi",
                },
            },
            profile: {
                title: "Profil",
                actions: {
                    registerEvent: "Daftar Event",
                    eventHistory: "Riwayat Event",
                },
                sections: {
                    personalInfo: "Informasi Pribadi"
                },
                fields: {
                    uusrName: "Nama",
                    uusrEmail: "Email",
                    uusrPhoneNumber: "Nomor Telepon",
                    uusrGender: "Jenis Kelamin",
                    uusrBloodType: "Golongan Darah",
                    uusrNationality: "Kewarganegaraan",
                    uusrIdentityType: "Jenis Identitas",
                    uusrIdentityNumber: "Nomor Identitas",
                    uusrDateOfBirth: "Tanggal Lahir",
                    uusrOccupation: "Pekerjaan",
                    uusrCommunity: "Komunitas",
                },
                gender: {
                    1: "Laki-laki",
                    2: "Perempuan",
                },
                identityType: {
                    1: "KTP",
                    2: "PASPOR",
                },
            },
            home: {
                about: AboutId,
                podium: PodiumHomeId,
                prize: PrizeHomeId,
                login: "Daftar Sekarang",
                profile: "Profil",
                logout: "Keluar",
            },
            gallery: {
                title: "Galeri",
            },
            raceinfo: {
                rrTitle:
                    "Para peserta diwajibkan untuk membaca seluruh peraturan dan ketentuan dibawah ini secara seksama sebelum mendaftarkan diri untuk Suroboyo 10K.",
                rr: RulesRegulationId,
                rrHeader: "Peraturan &",
                rrHeaderSub: "Regulasi",
                faqHeader: "Frequently Asked Question",
            },
            prize: PrizeId,
            faq: faqId,
            raceday: RaceDayId,
            contact: ContactId,
            registration: RegistrationId,
            kidsDash: {
                about: AboutKidsDashId,
                rrkdTitle:
                    "Para peserta diwajibkan untuk membaca seluruh aturan dan pedoman dibawah ini secara seksama sebelum mendaftarkan diri untuk Kids Dash Semarang 10K.",
                rrkd: RulesRegulationKidsDashId,
            }
        },
    },
};

i18n.use(initReactI18next).init({
    fallbackLng: "id",
    lng: "id",
    interpolation: {
        escapeValue: false,
    },
    resources: resources,
});

export default i18n;
